var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13.986 6.98a1.406 1.406 0 00-.475-1.05L6.99.19a.84.84 0 00-1.108 1.261l5.038 4.434a.146.146 0 01-.096.254H.84a.84.84 0 100 1.68h9.982a.146.146 0 01.096.256L5.88 12.508a.84.84 0 101.108 1.26L13.51 8.03c.302-.265.475-.648.476-1.05z",
    fill: "#005FFF",
    fillRule: "evenodd"
  })));
};

export default SvgArrowRight;